export const DEFAULT_APPLICATION_PHONE_NUMBER = '(844) 913-1386';

export const BREAKPOINT_TABLET = '(min-width: 768px)';
export const BREAKPOINT_DESKTOP = '(min-width: 992px)';
